import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import _ from 'lodash'
import PropTypes from 'prop-types'
import * as styles from './styles'
import { ApiEndpointIntro, Markdown, Section } from '../index'
import searchAnimation from '../../lottie-animations/query-search'
import predictAnimation from '../../lottie-animations/query-predict'
import recommendAnimation from '../../lottie-animations/query-recommend'
import likelihoodAnimation from '../../lottie-animations/query-likelihood'
import similarityAnimation from '../../lottie-animations/query-similarity'
import matchAnimation from '../../lottie-animations/query-match'
import relateAnimation from '../../lottie-animations/query-relate'
import genericAnimation from '../../lottie-animations/query-generic'

const propTypes = {
  data: PropTypes.object.isRequired
}

const AitoApiBlock = ({ data }) => {
  return (
    <styles.Container>
      <styles.BlockRow>
        <styles.BlockCol sm={1} xs={0} />
        <styles.BlockCol sm={7} xs={12}>
          <styles.BlockHeader>
            {data.aitoApiHeader}
          </styles.BlockHeader>
          <styles.BlockText>
            <Markdown>
              {data.aitoApiText}
            </Markdown>
          </styles.BlockText>
        </styles.BlockCol>
      </styles.BlockRow>

      <Section>
        <styles.ApiSection>
          <styles.ApiSectionRow>
            <styles.ApiSectionCol sm={1} xs={0} />
            <styles.ApiSectionCol sm={5} xs={12}>
              <ApiEndpointIntro
                animation={searchAnimation}
                header={data.api[0].name}
                text={data.api[0].text}
                url="https://aito.ai/docs/api/#post-api-v1-search"
              />
            </styles.ApiSectionCol>
            <styles.ApiSectionCol sm={5} xs={12}>
              <ApiEndpointIntro
                animation={predictAnimation}
                header={data.api[1].name}
                text={data.api[1].text}
                url="https://aito.ai/docs/api/#post-api-v1-predict"
              />
            </styles.ApiSectionCol>
          </styles.ApiSectionRow>

          <styles.ApiSectionRow>
            <styles.ApiSectionCol sm={1} xs={0} />
            <styles.ApiSectionCol sm={5} xs={12}>
              <ApiEndpointIntro
                animation={recommendAnimation}
                header={data.api[2].name}
                text={data.api[2].text}
                url="https://aito.ai/docs/api/#post-api-v1-recommend"
              />
            </styles.ApiSectionCol>
            <styles.ApiSectionCol sm={5} xs={12}>
              <ApiEndpointIntro
                animation={likelihoodAnimation}
                header={data.api[3].name}
                text={data.api[3].text}
                url="https://aito.ai/docs/api/#post-api-v1-evaluate"
              />
            </styles.ApiSectionCol>
          </styles.ApiSectionRow>

          <styles.ApiSectionRow>
            <styles.ApiSectionCol sm={1} xs={0} />
            <styles.ApiSectionCol sm={5} xs={12}>
              <ApiEndpointIntro
                animation={similarityAnimation}
                header={data.api[4].name}
                text={data.api[4].text}
                url="https://aito.ai/docs/api/#post-api-v1-similarity"
              />
            </styles.ApiSectionCol>
            <styles.ApiSectionCol sm={5} xs={12}>
              <ApiEndpointIntro
                animation={matchAnimation}
                header={data.api[5].name}
                text={data.api[5].text}
                url="https://aito.ai/docs/api/#post-api-v1-match"
              />
            </styles.ApiSectionCol>
          </styles.ApiSectionRow>

          <styles.ApiSectionRow>
            <styles.ApiSectionCol sm={1} xs={0} />
            <styles.ApiSectionCol sm={5} xs={12}>
              <ApiEndpointIntro
                animation={relateAnimation}
                header={data.api[6].name}
                text={data.api[6].text}
                url="https://aito.ai/docs/api/#post-api-v1-relate"
              />
            </styles.ApiSectionCol>
            <styles.ApiSectionCol sm={5} xs={12}>
              <ApiEndpointIntro
                animation={genericAnimation}
                header={data.api[7].name}
                text={data.api[7].text}
                url="https://aito.ai/docs/api/#post-api-v1-query"
              />
            </styles.ApiSectionCol>
          </styles.ApiSectionRow>
        </styles.ApiSection>
      </Section>

      <styles.BlockRow>
        <styles.BlockCol xs={1} />
        <styles.BlockCol xs={11}>
          <styles.PageForDevelopers>
            <Markdown>
              {data.aitoApiFooter}
            </Markdown>
          </styles.PageForDevelopers>
        </styles.BlockCol>
      </styles.BlockRow>
    </styles.Container>
  )
}

AitoApiBlock.propTypes = propTypes

export default () => (
  <StaticQuery
    query={graphql`
      query GetAitoApi {
        allYaml(filter: {file: {eq: "api-block"}}) {
          edges {
            node {
              aitoApiHeader
              aitoApiText
              aitoApiFooter
              
              api {
                name
                text
              }
            }
          }
        }
      }
    `
    }
    render={(data) => {
      const { allYaml } = data
      const { edges } = allYaml
      const { node } = _.first(edges)
      return (
        <AitoApiBlock data={node} />
      )
    }}
  />
)
